/**
 * 图片灯箱模块
 * 点击产品详情/新闻详情中的图片可放大查看
 * 支持 ESC 关闭、点击遮罩关闭
 */
export function initLightbox() {
  // 创建灯箱 DOM
  const overlay = document.createElement('div');
  overlay.className = 'lightbox-overlay';

  const closeBtn = document.createElement('button');
  closeBtn.className = 'lightbox-close';
  closeBtn.setAttribute('aria-label', '关闭');
  closeBtn.textContent = '\u00d7';

  const lightboxImg = document.createElement('img');
  lightboxImg.alt = '';

  overlay.appendChild(closeBtn);
  overlay.appendChild(lightboxImg);
  document.body.appendChild(overlay);

  // 为详情页中的图片添加可点击放大功能
  const detailImages = document.querySelectorAll(
    '.product-detail-image img, .product-detail-content img, .news-detail-content img, .rich-content img'
  );

  detailImages.forEach(img => {
    img.classList.add('zoomable');
    img.addEventListener('click', (e) => {
      e.preventDefault();
      lightboxImg.src = img.src;
      lightboxImg.alt = img.alt || '';
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  // 关闭灯箱
  function closeLightbox() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeLightbox);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeLightbox();
  });

  // ESC 关闭
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('active')) {
      closeLightbox();
    }
  });
}
